/**
 * Reagiert auf Klicks auf Elemente mit data-search, setzt den Wert
 * in das Suchfeld und sendet das Suchformular direkt ab.
 */
export function initQuickSearch(
    { formSelector = ".searchBar", triggerSelector = "[data-search]" } = {}
) {
    const getForm = () => document.querySelector(formSelector);

    const getSearchInput = (form) =>
        form?.querySelector(
            'input[type="search"], input[name="q"], input[name="search"], input:not([type]), input[type="text"]'
        );

    const getTriggerFromEvent = (event) => {
        const path = typeof event.composedPath === "function" ? event.composedPath() : [];

        for (const node of path) {
            if (!(node instanceof Element)) continue;
            if (node.matches(triggerSelector)) return node;
        }

        const target = event.target;
        if (target instanceof Element) {
            return target.closest(triggerSelector);
        }

        return null;
    };

    document.addEventListener(
        "click",
        (event) => {
            const trigger = getTriggerFromEvent(event);
            if (!trigger) return;

            const value = (trigger.dataset.search || "").trim();
            if (!value) return;

            const form = getForm();
            if (!form) return;

            const input = getSearchInput(form);
            if (!input) return;

            const link = trigger.closest("a[href]");
            if (link) event.preventDefault();

            input.value = value;
            input.dispatchEvent(new Event("input", { bubbles: true }));
            input.dispatchEvent(new Event("change", { bubbles: true }));

            if (typeof form.requestSubmit === "function") {
                form.requestSubmit();
            } else {
                form.submit();
            }
        },
        { capture: true }
    );
}